// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3u7Q8","errorLogs":"styles_errorLogs__2Q7ZX"};